<template>
  <aside class="admin-sidebar">
    <nav class="admin-sidebar-nav">
      <button
        v-for="item in menuItems"
        :key="item.path"
        class="admin-menu-item"
        :class="{ active: isActive(item.path) }"
        @click="$router.push(item.path)"
      >
        <component :is="item.icon" :size="16" />
        <span>{{ item.label }}</span>
        <div v-if="isActive(item.path)" class="menu-indicator" />
      </button>
    </nav>
  </aside>
</template>

<script>
import { Radar, Upload, BarChart3 } from 'lucide-vue-next'

export default {
  name: 'AdminSidebar',
  components: { Radar, Upload, BarChart3 },
  data() {
    return {
      menuItems: [
        { path: '/admin/crawlconfig', label: '采集配置', icon: 'Radar' },
        { path: '/admin/import', label: '数据导入', icon: 'Upload' },
        { path: '/admin/statistics', label: '数据统计', icon: 'BarChart3' },
      ],
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path || this.$route.path.startsWith(path + '/')
    },
  },
}
</script>
